//const palette = ['#333333', '#DDCBBE', '#D7DEEA', '#A1A9C4', '#A0807B', '#ccc']
const palette = ['#333333', '#6e8acc', '#cc976e', '#ccc66e', '#be6ecc', '#92c257', '#c25792', '#c26e57', '#57c2b7']

export const categoryColor = id => {
  if (id > palette.length - 1) return palette[0]
  else return palette[id]
}
